import React, { useEffect, useMemo, useState } from 'react';
import { Button, Modal, OverlayTrigger, Spinner, Tooltip } from 'react-bootstrap';
import Disposisi from '../../../utilities/Disposisi';
import MasterService from '../../../services/master/MasterService';
import { FaEye } from 'react-icons/fa';
import { AsyncPaginate } from 'react-select-async-paginate';
import SweetAlert from 'react-bootstrap-sweetalert';
import { getCurrentDateFormatted, romanNum } from '../../../utilities/Utils';
import TransaksiService from '../../../services/transaksi/TransaksiService';
import PbUmkuService from '../../../services/pbumku/PbumkuService';
import GetDokumen from '../../../utilities/GetDokumen';
import GetDokumenTanggal from '../../../utilities/GetDokumenTanggal';

const ModalLapEv = ({ showAddLapEv, handleCloseAddLapEv, dataDisposisi, datappm, reloadList }) => {
    const currentDate = new Date()
    const currentMonth = currentDate.getMonth() + 1
    const currentYear = currentDate.getFullYear()

    const [listDokumenWajib, setListDokumenWajib] = useState([])
    const [listPenugasanDetil, setListPenugasanDetil] = useState([])
    let masterService = useMemo(() => new MasterService(), [])
    let transaksiService = useMemo(() => new TransaksiService(), [])
    let pbumkuService = useMemo(() => new PbUmkuService(), [])

    const [stsInv, setStsInv] = useState('')
    const [stsPackList, setStsPackList] = useState('')
    const [stsHaccp, setStsHaccp] = useState('')
    const [stsSurv, setStsSurv] = useState('')
    const [stsReg, setStsReg] = useState('')
    const [valueKeterangan, setValueKeterangan] = useState(null)

    const [loadingSave, setLoadingSave] = useState(false)

    useEffect(() => {
        const getListDokWajib = async () => {
            const response = await masterService.listDokumenWajib(0, 0, 20)
            setListDokumenWajib(response.data.data)
        }
        getListDokWajib()
    }, [masterService])

    useEffect(() => {
        if (!dataDisposisi) return
        const getSpp = async () => {
            try {
                const resSpp = await transaksiService.listPenugasan(datappm.nomorAju, 2, 0, 10)
                const resTugasDetil = await transaksiService.listPenugasanDetil(datappm.nomorAju, resSpp.data.data[0].noTugas)
                setListPenugasanDetil(resTugasDetil.data)
            } catch (error) {
                setListPenugasanDetil([])
            }
        }
        getSpp()
    }, [transaksiService, dataDisposisi, datappm])

    const [valueKesimpulanOpt, setValueKesimpulanOpt] = useState(null)

    async function loadOptionKesimpulan(search, loadedOption, { page = 1 }) {
        const response = await masterService.listKesimpulan('lhd', search, page - 1, 20)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }

    const onChangeKesimpulan = e => {
        setValueKesimpulanOpt(e)
    }

    const handleChangeKeterangan = e => {
        setValueKeterangan(e.target.value)
    }

    const [showConfirmSaveLap, setShowConfirmSaveLap] = useState(false)
    const handleCloseConfirmSaveLap = () => setShowConfirmSaveLap(false)
    const [showLapSuccess, setShowLapSuccess] = useState(false)
    const [showLapFailed, setShowLapFailed] = useState(false)
    const [rowLap, setRowLap] = useState(null)


    const SaveLapEv = (dataDisposisi) => {
        setShowConfirmSaveLap(true)
        setRowLap(dataDisposisi)
    }

    const handleClickSaveLap = async () => {
        setLoadingSave(true)
        try {
            const respNomor = await pbumkuService.ambilNomorService('PPM_SPT_LE', datappm.kdUpt, currentYear, localStorage.getItem('username'))
            let noSuratTugasTemp = respNomor.data.uraianPusat + '/' + respNomor.data.kodePusat + '/' + romanNum(currentMonth) + '/' + currentYear + '/' + respNomor.data.nomorUrut

            let dataPpm = ''
            let jsonlap = { ...rowLap, noTugas: noSuratTugasTemp, tglTugas: getCurrentDateFormatted(), createdBy: localStorage.getItem("userId"), createdAt: new Date() }
            const _resLap = await transaksiService.addPenugasan(jsonlap)
            if (_resLap.data.kode === '200') {
                let jsonHasilEvPermohonan = {
                    nomorAju: datappm.nomorAju,
                    tglTugas: getCurrentDateFormatted(),
                    nipInspektur: listPenugasanDetil[0].nipPetugas,
                    stsInv: stsInv,
                    stsPackList: stsPackList,
                    stsHaccp: stsHaccp,
                    stsSurv: stsSurv,
                    stsReg: stsReg,
                    idKesimpulan: valueKesimpulanOpt.idKesimpulan,
                    kseimpulan: valueKesimpulanOpt.kesimpulan,
                    disposisi: valueKesimpulanOpt.idDisposisi,
                    dateCreate: new Date(),
                    operator: localStorage.getItem('userId'),
                    noTugas: noSuratTugasTemp,
                    keterangan: valueKeterangan
                }
                const _resHasilEv = await transaksiService.addHasilEvPermohonan(jsonHasilEvPermohonan)
                if (_resHasilEv.data.kode === '200') {
                    if (valueKesimpulanOpt.idDisposisi === '4') {
                        let jsonSppEvTeknis = { idDisposisi: 5, nomorAju: datappm.nomorAju }

                        await transaksiService.addPenugasan(jsonSppEvTeknis)

                        dataPpm = { ...datappm, status: '022' }
                        let dataStatus = {
                            nomorAju: datappm.nomorAju,
                            kodeStatus: '022',
                            waktuStatus: new Date(),
                            createdBy: localStorage.getItem('username')
                        }
                        await transaksiService.addPpmStatus(JSON.stringify(dataStatus))
                    } else {
                        // let jsonnext = { idDisposisi: valueKesimpulanOpt.idDisposisi, nomorAju: datappm.nomorAju }
                        // await transaksiService.addPenugasan(jsonnext)

                        dataPpm = { ...datappm, status: '110' }
                        let dataStatus = {
                            nomorAju: datappm.nomorAju,
                            kodeStatus: '110',
                            waktuStatus: new Date(),
                            createdBy: localStorage.getItem('username')
                        }
                        await transaksiService.addPpmStatus(JSON.stringify(dataStatus))
                    }
                    await transaksiService.addPpm(dataPpm)
                    setShowLapSuccess(true)
                } else {
                    setShowLapFailed(true)
                }
                setShowConfirmSaveLap(false)
            }
        } catch (error) {
            console.log(error)
            setShowLapFailed(true)
        }
        setLoadingSave(false)
    }

    const handleClickLapSuccess = () => {
        setShowLapSuccess(false)
        reloadList(datappm.nomorAju, 0, 10)
    }

    const handleClickLapFailed = () => {
        setShowLapFailed(false)
    }

    const handleChangeRadio = (e) => {
        let targetId = e.target.id
        const splitIndex = targetId.search(/\d/)
        let targetString = targetId.substring(splitIndex)

        switch (targetString) {
            case '217':
                setStsPackList(e.target.value)
                break;
            case '380':
                setStsInv(e.target.value)
                break;
            case '1009':
                setStsHaccp(e.target.value)
                break;
            case '1006':
                setStsSurv(e.target.value)
                break;
            case '1017':
                setStsReg(e.target.value)
                break;
            default:
                break;
        }
    }

    const [showOpenPreview, setShowOpenPreview] = useState(false)
    const handleClosePreview = () => {
        setBase64String(null)
        setShowOpenPreview(false)
    }

    const [base64String, setBase64String] = useState(null)

    const handleClickPreviewDok = async (idJnsDok, nomorAju) => {
        try {
            const resDok = await transaksiService.getPpmDokByAjuKodeDok(nomorAju, idJnsDok)
            if (resDok.data !== '') {
                setBase64String(resDok.data.dokPath)
                setShowOpenPreview(true)
            }
        } catch (error) {
            console.log(error)
        }
    }

    return (
        <>
            <Modal show={showAddLapEv}
                onHide={handleCloseAddLapEv}
                backdrop='static'
                keyboard={false}
                size="xl"
                centered
            >
                <Modal.Header>
                    <h6><Disposisi idDisposisi={dataDisposisi.idDisposisi} /></h6>
                </Modal.Header>
                <Modal.Body>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Nomor Aju</label>
                        <div className="col-sm-6">
                            <input type="text" className="col-sm-12 form-control-sm" name="nomor_aju" defaultValue={datappm.nomorAju} readOnly />
                        </div>
                    </div>
                    <div className='row mb-3'>
                        {
                            listDokumenWajib.map((dokwajib, index) => {
                                return (
                                    <>
                                        <div key={index} className='row mb-3'>
                                            <div className="col-sm-10">
                                                <label className="col-sm-1 col-form-label-sm">{index + 1}</label>
                                                <label className="col-sm-8 col-form-label-sm" name="dokwajib"><strong>{dokwajib.dokumen}</strong></label>
                                            </div>
                                            <div className="col-sm-6">
                                                <strong>Nomor</strong> : <GetDokumen nomorAju={datappm.nomorAju} idJnsDok={dokwajib.idJnsDok} />,{' '}
                                                <strong>Tanggal</strong> : <GetDokumenTanggal nomorAju={datappm.nomorAju} idJnsDok={dokwajib.idJnsDok} />
                                            </div>
                                            <div className='col-sm-3'>
                                                <div className="col-sm-12">
                                                    <div class="form-check form-check-inline">
                                                        <input class="form-check-input"
                                                            type="radio" name={'inlineRadio' + dokwajib.idJnsDok}
                                                            id={'inlineRadio' + dokwajib.idJnsDok}
                                                            value="1"
                                                            onChange={(e) => handleChangeRadio(e)} />
                                                        <label class="form-check-label" for={'inlineRadio' + dokwajib.idJnsDok}>Sesuai</label>
                                                    </div>
                                                    <div class="form-check form-check-inline">
                                                        <input class="form-check-input"
                                                            type="radio"
                                                            name={'inlineRadio' + dokwajib.idJnsDok}
                                                            id={'inlineRadio' + dokwajib.idJnsDok}
                                                            value="0"
                                                            onChange={(e) => handleChangeRadio(e)} />
                                                        <label class="form-check-label" for={'inlineRadio' + dokwajib.idJnsDok}>Tidak Sesuai</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-sm-2'>
                                                <OverlayTrigger placement="bottom" overlay={
                                                    <Tooltip >Preview Dokumen</Tooltip>
                                                }>
                                                    <Button size="sm" variant="outline-info" onClick={() => handleClickPreviewDok(dokwajib.idJnsDok, datappm.nomorAju)}>
                                                        <FaEye /> Preview
                                                    </Button>
                                                </OverlayTrigger>{' '}
                                            </div>
                                        </div>
                                    </>
                                )
                            })
                        }
                    </div>
                    <div className='row mb-3'>
                        <label className="col-sm-2 col-form-label-sm">Kesimpulan</label>
                        <div className='col-sm-8'>
                            <AsyncPaginate
                                loadOptions={loadOptionKesimpulan}
                                value={valueKesimpulanOpt}
                                getOptionLabel={(option) => option.kesimpulan}
                                getOptionValue={(option) => option.idKesimpulan}
                                additional={{
                                    page: 1
                                }}
                                onChange={onChangeKesimpulan}
                            />
                        </div>
                    </div>
                    {
                        valueKesimpulanOpt && valueKesimpulanOpt.idKesimpulan === 3 &&
                        <div className="row mb-3">
                            <label className="col-sm-2 col-form-label-sm">Alasan Penolakan</label>
                            <div className="col-sm-6">
                                <textarea cols={6} rows={5} className="col-sm-12 form-control-sm" name="keterangan" value={valueKeterangan} onChange={handleChangeKeterangan} />
                            </div>
                        </div>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" size="sm" onClick={() => SaveLapEv(dataDisposisi)}>Simpan</Button>{' '}
                    <Button variant="danger" size="sm" onClick={handleCloseAddLapEv}>Batal</Button>
                </Modal.Footer>
            </Modal>
            {
                showConfirmSaveLap &&
                <SweetAlert
                    title="Proses Laporan?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingSave ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Simpan...
                            </>
                        ) : (
                            "Proses"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickSaveLap}
                    onCancel={handleCloseConfirmSaveLap}
                    focusCancelBtn
                    reverseButtons={true}
                    btnSize="sm"
                    disabled={loadingSave}
                >
                    {loadingSave && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Proses data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showLapSuccess &&
                <SweetAlert
                    title="Laporan Berhasil"
                    success
                    onConfirm={handleClickLapSuccess}
                    btnSize="sm"
                />
            }
            {
                showLapFailed &&
                <SweetAlert
                    title="Laporan Gagal"
                    danger
                    onConfirm={handleClickLapFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
            <PreviewPdf showOpenPreview={showOpenPreview} handleClosePreview={handleClosePreview} base64string={base64String} />
        </>
    )
}

const PreviewPdf = ({ showOpenPreview, handleClosePreview, base64string }) => {
    return (
        <>
            <Modal show={showOpenPreview} onHide={handleClosePreview} size='xl'>
                <iframe
                    src={base64string}
                    title='Preview PDF'
                    width="100%"
                    height="800px"
                ></iframe>
            </Modal>
        </>
    )
}

export default ModalLapEv